export { default } from './Subheading';